import model from './model';
import { AccessPointDetailsPage } from './pages/AccessPointDetailsPage';

model.routes.setRoutes({
  detailsRoute: {
    component: AccessPointDetailsPage,
  },
});
